module.exports = __webpack_public_path__ + "img/角度锁定.69f902c4.svg";